import React from "react";
import { connect } from "react-redux";
import Button from "Components/button/Button";
import { displayFormattedDate } from "Utils/dateFormats";
import PropTypes from "prop-types";
import TranslatedString from "Components/TranslatedString";
import { plus } from "Icons/index";
import { t } from "i18next";
import { withRouter } from "react-router";
import cx from "classnames";
import s from "./yearlyOrder.scss";
import currency from "currency.js";
import { Icon, arrowRight } from "Icons/index";

const DomainCard = props => {
  const ordered = typeof props.plan !== "object";
  const plan = typeof props.plan === "object" ? props.plan.name : props.plan;
  const { prices } = props;
  const price8 = prices.annually[`${plan}_8`];
  const price25 = prices.annually[`${plan}_25`];
  const priceVault = prices.annually[`${plan}_vault`];

  const partial8 = currency(price8).multiply(props.max_email_accounts);
  const partial25 = currency(price25).multiply(props.max_email_accounts_25gb);
  const partialVault = currency(priceVault).multiply(props.max_email_accounts_archive);

  const total = currency(partial8)
    .add(partial25)
    .add(partialVault)
    .format();

  let waitingPaymentOrder = props.upgradingProducts[props.whmcs_product_id];

  if (ordered && !waitingPaymentOrder) {
    waitingPaymentOrder = props.upgradingProducts[props.order_id];
  }

  let nextPlan;
  let next8;
  let next25;
  let next50;
  let nextArchive;

  if (waitingPaymentOrder) {
    if (waitingPaymentOrder.plan !== props.plan) nextPlan = waitingPaymentOrder.plan;

    // if has a new plan it means it cannot have even more email
    if (!nextPlan && waitingPaymentOrder.max_emails_no_8gb > 0) {
      next8 = props.max_email_accounts + waitingPaymentOrder.max_emails_no_8gb;
    }

    if (!nextPlan && waitingPaymentOrder.max_emails_no_25gb > 0) {
      next25 = props.max_email_accounts_25gb + waitingPaymentOrder.max_emails_no_25gb;
    }

    if (!nextPlan && waitingPaymentOrder.max_emails_no_archive > 0) {
      nextArchive = props.max_email_accounts_archive + waitingPaymentOrder.max_emails_no_archive;
    }
  }

  return (
    <div className={s.domainCard}>
      <div className={cx(s.headerDC, { [s.waitingPay]: waitingPaymentOrder })}>
        <div className={s.wrapTitleDC}>
          <div className={s.titleDC}> {props.name}</div>
          {waitingPaymentOrder && (
            <div className={s.labelWaitingPay}>{t("orders.list.card.field.waitingPayment")}</div>
          )}
        </div>

        {!waitingPaymentOrder && false && (
          <Button
            disabled={waitingPaymentOrder}
            color="outline"
            onClick={props.setUpgradingDomains}
          >
            button.edit
          </Button>
        )}

        {waitingPaymentOrder && (
          <Button
            className={s.payBtn}
            color="green"
            onClick={() => props.showWHMCInvoice(waitingPaymentOrder)}
          >
            button.pay
          </Button>
        )}
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.date</TranslatedString>
        {new Date(ordered ? props.order?.created_at : props.created_at).toLocaleDateString()}
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.plan</TranslatedString>
        <b>
          {plan}
          {nextPlan ? (
            <>
              <Icon svg={arrowRight} height={"8px"} className={s.upgradeArrow} />
              {nextPlan}
            </>
          ) : (
            ""
          )}
        </b>
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.em8gb</TranslatedString>
        <span className={s.price}>
          <b>
            {props.max_email_accounts - props.max_email_accounts_25gb}
            {next8 ? (
              <>
                <Icon svg={arrowRight} height={"8px"} className={s.upgradeArrow} />
                {next8}
              </>
            ) : (
              ""
            )}
          </b>{" "}
          x € {price8}
        </span>
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.em25gb</TranslatedString>
        <span className={s.price}>
          <b>
            {props.max_email_accounts_25gb}
            {next25 ? (
              <>
                <Icon svg={arrowRight} height={"8px"} className={s.upgradeArrow} />
                {next25}
              </>
            ) : (
              ""
            )}
          </b>{" "}
          x € {price25}
        </span>
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.emArchive</TranslatedString>
        <span className={s.price}>
          {" "}
          <b>
            {props.max_email_accounts_archive}
            {nextArchive ? (
              <>
                <Icon svg={arrowRight} height={"8px"} className={s.upgradeArrow} />
                {nextArchive}
              </>
            ) : (
              ""
            )}
          </b>{" "}
          x € {priceVault}
        </span>
      </div>

      <div className={s.field}>
        <TranslatedString>orders.list.card.field.total</TranslatedString>€ {total}
      </div>
    </div>
  );
};

const propTypes = {};

const ContextTypes = {
  router: PropTypes.object,
  getLoggedUser: PropTypes.func,
  getLoggedUserType: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func
};

class YearlyOrder extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      setUpgradingDomains,
      setAddingDomain,
      domains,
      prices,
      normalizedOrders,
      showWHMCInvoice,
      upgradingProducts
    } = this.props;

    const { isMediaMobile } = this.context;

    return (
      <div className={s.listYearlyOrder}>
        <div className={s.headerList}>
          <div className={cx("sectionTitle", s.titleList)}>
            <TranslatedString>orders.list.header.title</TranslatedString>
          </div>

          {!isMediaMobile() && (
            <div className={cx("sectionDesc", s.descList)}>
              <TranslatedString>orders.list.header.dsc</TranslatedString>
            </div>
          )}

          <div className={s.actionsList}>
            <Button docsKey="orders" color="docs" className={s.btnList} onlyIcon={isMediaMobile()}>
              button.docs
            </Button>
            <Button icon={plus} onClick={setAddingDomain} onlyIcon={isMediaMobile()}>
              orders.list.header.newDomain
            </Button>
          </div>
        </div>
        <div className={s.contentList}>
          {domains.map(dom => {
            return (
              <DomainCard
                {...dom}
                key={dom.name}
                setUpgradingDomains={() => {
                  this.props.history.push("/orders#1");
                  setUpgradingDomains([dom], true);
                }}
                order={normalizedOrders[dom.order_id]}
                upgradingProducts={upgradingProducts}
                showWHMCInvoice={showWHMCInvoice}
                prices={prices}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

//YearlyOrder.propTypes = propTypes;
YearlyOrder.contextTypes = ContextTypes;

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(YearlyOrder));
